import React from "react";
import { useTranslation } from "react-i18next";

interface StepBoxProps {
    number: string;
    icon: string;
    text: string;
}

export const StepBox: React.FC<StepBoxProps> = ({ number, icon, text }) => {
    const { t } = useTranslation();

    return (
        <div className="box">
            <span>{number}</span>
            <i className={icon}></i>
            <p>{text}</p>
        </div>
    );
};
